import { render } from "./pools.vue?vue&type=template&id=1a905caa"
import script from "./pools.vue?vue&type=script&lang=js"
export * from "./pools.vue?vue&type=script&lang=js"

import "./pools.vue?vue&type=style&index=0&id=1a905caa&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__